import 'css-chunksrc/client/scenes/assignToTask/tasksSelection/checkbox/styles.scss';export default {
  "checkbox": "_checkbox_5tors_1",
  "checked": "_checked_5tors_12"
};